import React from 'react'
import AboutIcon from '../../assets/img/logo/favicon.png';
import { Link } from 'react-router-dom';
import empowerImg from '../../assets/img/empower.png'
import Img3 from '../../assets/img/cad.png';
import Img4 from '../../assets/img/phone.png';
import { Helmet } from "react-helmet-async";

function VirtualAccount() {
    const dashboardBaseUrl = process.env.REACT_APP_DASHBOARD_BASE_URL;
    return (
        <>
            <Helmet>
                <title>Virtual Account | Cardplot</title>
            </Helmet>
            <section className='breadcrumb__section__02 padding__tb__100'>
                <div className="container">
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className="breadcrumb__title__head">
                                <ol className="breadcrumb">
                                    <li className="active"><img src={AboutIcon} style={{ width: '25px', height: '25px' }} alt="" /></li>
                                </ol>
                                <h2 className='breadcrumb__title'> FEATURES </h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="breadcrumb__text">
                                <h3 className='breadcrumb__text__head'>Virtual Accounts</h3>
                                <p className='breadcrumb__text__content '>
                                    At Cardplot we believe financial boundaries should never limit your potential. That’s why we bring you Virtual Accounts, a revolutionary solution tailored for the diverse and dynamic needs of individuals and businesses across Africa.
                                </p>
                            </div>
                            <div className='d-flex gap-3 justify-content-center align-items-center' style={{ paddingTop: '40px' }}>
                                <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                    Get Started
                                </a>
                                <Link to='/contact' className='btn btn__outline_primary '>Contact us</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='virtual__section virtual__section__get__account padding__tb__50'>
                <div className='container'>
                    <div className='virtual__section__get__account__container'>
                        <div className='row justify-content-between align-items-center'>
                            <div className='col-12 col-md-6 mb-5 mb-lg-0'>
                                <div className='virtual__section__content'>
                                    <p>
                                        Cardplot is a pan-African payment solution offering flexible virtual accounts that support multiple currencies and seamless cross-border transactions.
                                    </p>
                                    <p>
                                        With 24/7 accessibility, it simplifies financial management for businesses and individuals, eliminating the need for physical bank visits.
                                    </p>
                                    <Link to='' className='btn btn__primary mt-4'>Get Account</Link>
                                </div>
                            </div>
                            <div className='col-12 col-md-6 mt-4 mb-5 mb-lg-0 '>
                                <div className='virtual__section__image text-end'>
                                    <img src={Img3} className='img-fluid' alt='virtual cards' />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='create__virtual__card__section padding__tb__50'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-md-12'>
                            <div className='position-relative'>
                                <h2 className='create__virtual__card__section__title'>What you get:</h2>
                            </div>
                        </div>
                    </div>
                    <div className='create__virtual__account__section__content'>
                        <div className='create__virtual__account__section__content_left'>
                          <img src={Img4} alt="Phone mockup" class="img-fluid" />
                        </div>
                        <div className='create__virtual__account__section__content_right'>
                            <div className='create__virtual__card__section__content__item'>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        1
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Borderless Payments</h4>
                                        <p>Our Virtual Accounts empower you to receive payments in multiple currencies, giving you the flexibility to transact effortlessly within and beyond Africa.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        2
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Quick and Reliable</h4>
                                        <p>Experience instant payment notifications and real-time transaction tracking, ensuring your funds are where you need them, when you need them.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        3
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Cost-Effective</h4>
                                        <p>Avoid exorbitant transfer fees and hidden charges. Cardplot ensures that your money works for you, not against you.</p>
                                    </div>
                                </div>
                                <div className='create__virtual__card__section__content__item__box mb-4'>
                                    <div className='create__virtual__card__section__content__item__box__icon'>
                                        4
                                    </div>
                                    <div className='create__virtual__account__item'>
                                        <h4>Culturally Tailored Experience</h4>
                                        <p>At Cardplot, we celebrate Africa's rich diversity. Our Virtual Accounts are designed with an understanding of local markets and customer needs, making financial transactions as simple as sending a text.</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <section className='empower_your_trade overlay'>
                <div className="container">
                    <div className="row justify-content-center align-items-center">
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__title">
                                <h2>Ready to simplify your payments?</h2>
                                <p>Simplify Your Exchange, Empower Your Trade</p>
                                <div className='d-flex gap-3' style={{ paddingTop: '60px' }}>
                                    <a className='btn btn__primary' href={`${dashboardBaseUrl}/getstarted`} target="_blank" rel="noopener noreferrer">
                                        Get Started
                                    </a>
                                    <Link to='/contact' className='btn btn__outline_primary'>Contact us</Link>
                                </div>
                            </div>
                        </div>
                        <div className="col-12 col-lg-6 mb-4 mb-lg-0">
                            <div className="empower__img">
                                <img src={empowerImg} className='img-fluid' alt="empower" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default VirtualAccount